var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    [
      _c(
        "vue-form-group",
        { attrs: { errors: _vm.errors["title"], label: "Tytuł *" } },
        [
          _c("vue-text", {
            attrs: { "is-invalid": "title" in _vm.errors, name: "title" },
            model: {
              value: _vm.guide.title,
              callback: function ($$v) {
                _vm.$set(_vm.guide, "title", $$v)
              },
              expression: "guide.title",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vue-form-group",
        { attrs: { errors: _vm.errors["role"], label: "Rola *" } },
        [
          _c("vue-select", {
            attrs: {
              options: _vm.roles,
              placeholder: "--",
              "is-invalid": "role" in _vm.errors,
              name: "role",
            },
            model: {
              value: _vm.guide.role,
              callback: function ($$v) {
                _vm.$set(_vm.guide, "role", $$v)
              },
              expression: "guide.role",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vue-form-group",
        { attrs: { errors: _vm.errors["excerpt"], label: "Opis" } },
        [
          _c("vue-markdown", {
            attrs: { "is-invalid": "excerpt" in _vm.errors, name: "excerpt" },
            on: { save: _vm.save },
            model: {
              value: _vm.guide.excerpt,
              callback: function ($$v) {
                _vm.$set(_vm.guide, "excerpt", $$v)
              },
              expression: "guide.excerpt",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vue-form-group",
        { attrs: { errors: _vm.errors["text"], label: "Odpowiedź *" } },
        [
          _c("vue-markdown", {
            attrs: {
              "is-invalid": "text" in _vm.errors,
              assets: _vm.guide.assets,
            },
            on: {
              save: _vm.save,
              "update:assets": function ($event) {
                return _vm.$set(_vm.guide, "assets", $event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "bottom",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "row no-gutters p-1" },
                      [
                        _c("vue-tags-inline", {
                          class: { "is-invalid": "tags" in _vm.errors },
                          attrs: {
                            tags: _vm.guide.tags,
                            placeholder: "...inny? kliknij, aby wybrać tag",
                          },
                          on: { change: _vm.TOGGLE_TAG },
                        }),
                        _vm._v(" "),
                        _c("vue-error", {
                          attrs: { message: _vm.errors["tags"] },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.guide.text,
              callback: function ($$v) {
                _vm.$set(_vm.guide, "text", $$v)
              },
              expression: "guide.text",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-2" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "vue-button",
              {
                staticClass: "btn btn-primary btn-sm",
                attrs: {
                  disabled: _vm.isProcessing,
                  tabindex: "4",
                  title: "Kliknij, aby zapisać (Ctrl+Enter)",
                },
                nativeOn: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.save.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n        Zapisz\n      ")]
            ),
            _vm._v(" "),
            _vm.guide.id
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-danger mr-2",
                    attrs: { title: "Anuluj (Esc)", tabindex: "3" },
                    on: { click: _vm.cancel },
                  },
                  [_vm._v("\n        Anuluj\n      ")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }